import { API_URL } from '../../../app-config/constants';
import type { AutomationsSettingsDto } from '../../react/features/Automations/types';
import { get, post } from '../request';

const BASE_URL = `${API_URL}/automations`;

getAutomationsSettings.operation = 'READ';
getAutomationsSettings.idFrom = 'ARGS';
export function getAutomationsSettings(): Promise<AutomationsSettingsDto> {
    return get<AutomationsSettingsDto>(`${BASE_URL}/settings`);
}

setAutomationsSettings.operation = 'NO_OPERATION';
setAutomationsSettings.invalidates = ['getAutomationsSettings'];
export function setAutomationsSettings(settings: AutomationsSettingsDto) {
    return post<AutomationsSettingsDto>(`${BASE_URL}/settings`, { postData: settings });
}
